export default {"src":"/_next/static/media/zoom-in.b8b9ea2e.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};